import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonsWrapper, Form, Separator } from '@thinknet-gmbh/platform-common-ui';

import { useUpdateApplicantById } from 'src/hooks/applicants/update-applicant-by-id.hook';
import { ApplicantFeedbacksFormList } from 'src/pages/vacancies/sub-pages/vacancy-details/components/applicants/components/applicant-details/components/applicant-details-form/components/applicant-feedbacks-form-list';

import { ApplicantFeedbacksInfo } from './components/applicant-feedbacks-info';

const ApplicantFeedbacks = ({
  applicant,
  responsiblePersons,
}: {
  applicant: any;
  responsiblePersons: any;
}) => {
  const { t } = useTranslation('common');
  const [isEdit, setIsEdit] = useState(false);
  const { updateApplicant } = useUpdateApplicantById({ onSuccess: () => setIsEdit(false) });

  return isEdit ? (
    <Form
      layout="vertical"
      onFinish={payload => updateApplicant({ variables: { payload, applicantId: applicant._id } })}
      initialValues={{
        feedbacks: applicant.feedbacks,
      }}
    >
      <Separator />
      <ApplicantFeedbacksFormList responsiblePersons={responsiblePersons} />
      <Separator />
      <ButtonsWrapper style={{ margin: '24px 0' }}>
        <Button type="primary" htmlType="submit">
          {t('buttons.save')}
        </Button>
        <Button onClick={() => setIsEdit(false)}>{t('buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  ) : (
    <>
      <Separator />
      <ApplicantFeedbacksInfo feedbacks={applicant.feedbacks} onClickEdit={() => setIsEdit(true)} />
    </>
  );
};

export default ApplicantFeedbacks;
